// src/pages/AdminUsers.js
import React, { useEffect, useState } from "react";
import api from "../../utils/api";

const ResturantUsers = ({ mode = "business" }) => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch all admins
  const fetchAdmins = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const res = await api.get("admin/restaurant/user/all", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }); // GET API
      const allAdmins = res?.data || [];
      
      // Filter based on mode (all businesses now)
      const filtered = allAdmins.filter(admin => {
        return !admin.restaurant?.parent_id || admin.restaurant?.parent_id === "";
      });
      
      setAdmins(filtered);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Toggle active status
  const toggleStatus = async (id, status) => {
    try {
      await api.post("admin/restaurant/user/toggle-active", {
        id,
        activeStatus: status,
      });
      fetchAdmins(); // refresh list
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">
          Business Admins
        </h2>
        <span className="bg-rose-100 text-rose-700 px-4 py-1 rounded-full text-sm font-medium">
          Total: {admins.length}
        </span>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
           <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-rose-600"></div>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <table className="w-full text-left border-collapse">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Admin Details</th>
                <th className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Contact</th>
                <th className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Restaurant</th>
                <th className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Location</th>
                <th className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th>
                <th className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {admins.map((admin) => (
                <tr key={admin.id} className="hover:bg-gray-50/50 transition-colors">
                  <td className="p-4 text-sm">
                    <div className="font-bold text-gray-900">{admin.first_name} {admin.last_name}</div>
                    <div className="text-gray-500 text-xs">ID: {admin.id}</div>
                  </td>
                  <td className="p-4 text-sm">
                    <div className="text-gray-700">{admin.mobile}</div>
                    <div className="text-gray-500 text-xs">{admin.email}</div>
                  </td>
                  <td className="p-4 text-sm">
                    <div className="font-semibold text-rose-600">{admin.restaurant?.business_name || "-"}</div>
                    <div className="text-xs text-gray-500">Code: {admin.restaurant?.restaurant_code || "-"}</div>
                  </td>
                  <td className="p-4 text-sm text-gray-700">{admin.restaurant?.city || "-"}</td>
                  <td className="p-4 text-sm">
                    {admin.active_status === 0 && (
                      <span className="bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full text-xs font-medium">Pending</span>
                    )}
                    {admin.active_status === 1 && (
                      <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-full text-xs font-medium">Approved</span>
                    )}
                    {admin.active_status === 2 && (
                      <span className="bg-red-100 text-red-700 px-2 py-0.5 rounded-full text-xs font-medium">Rejected</span>
                    )}
                  </td>
                  <td className="p-4">
                    <div className="flex gap-2">
                      <button
                        onClick={() => toggleStatus(admin.id, 1)}
                        className="bg-green-50 hover:bg-green-100 text-green-600 p-2 rounded-lg transition-colors"
                        title="Approve"
                      >
                        ✓
                      </button>
                      <button
                        onClick={() => toggleStatus(admin.id, 2)}
                        className="bg-red-50 hover:bg-red-100 text-red-600 p-2 rounded-lg transition-colors"
                        title="Reject"
                      >
                        ✕
                      </button>
                      <button
                        onClick={() => toggleStatus(admin.id, 0)}
                        className="bg-amber-50 hover:bg-amber-100 text-amber-600 p-2 rounded-lg transition-colors"
                        title="Reset to Pending"
                      >
                        ⟳
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ResturantUsers;
